import {
	Directive,
	ElementRef,
	HostListener,
	Input,
	OnInit,
	Renderer2,
	inject,
	effect,
	signal
} from '@angular/core';

interface DragOptions {
	container: string;
	draggable?: boolean
	start?: (e: MouseEvent) => void;
	drag?: (e: MouseEvent) => void;
	stop?: (e: MouseEvent) => void;
}

@Directive({
	selector: '[draggableElem]'
})
export class DraggableElemDirective implements OnInit {
	@Input('draggableElem') dragOptions: DragOptions | undefined;

	private el = inject(ElementRef<HTMLElement>);
	private renderer = inject(Renderer2);

	private startX = 0;
	private startY = 0;
	private x = 0;
	private y = 0;

	private container: DOMRect | null = null;
	private offsetLeft = 0;
	private offsetTop = 0;

	ngOnInit() {
		this.init();
	}

	private init() {
		if (!this.dragOptions?.container) return;

		const elem = this.el.nativeElement;

		const containerElem = document.getElementById(this.dragOptions.container);
		if (!containerElem) return;

		const containerBounds = containerElem.getBoundingClientRect();
		const elemBounds = elem.getBoundingClientRect();

		const borderWidth = parseInt(getComputedStyle(containerElem).borderWidth || '0');

		this.container = new DOMRect(
			containerBounds.left + borderWidth,
			containerBounds.top + borderWidth,
			containerBounds.width - 2 * borderWidth,
			containerBounds.height - 2 * borderWidth
		);

		const advancedPanel = document.getElementById('advancedPanelMainConent')?.getBoundingClientRect();
		this.x = containerBounds.right - Math.abs(elemBounds.width - (advancedPanel?.width || 0));

		const navbarPanel = document.getElementById('maincontent_navbar')?.getBoundingClientRect();
		const searchbarPanel = document.getElementById('maincontent_searchbar')?.getBoundingClientRect();
		const headerbarPanel = document.getElementById('maincontent_header')?.getBoundingClientRect();
		this.y = containerBounds.top - ((navbarPanel?.height || 0) + (searchbarPanel?.height || 0) + (headerbarPanel?.height || 0));

		this.setPosition();
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent) {
		if (this.dragOptions?.draggable === false) return;

		event.preventDefault();

		const elem = this.el.nativeElement;

		this.startX = event.clientX - elem.offsetLeft;
		this.startY = event.clientY - elem.offsetTop;

		document.addEventListener('mousemove', this.mouseMove);
		document.addEventListener('mouseup', this.mouseUp);

		if (this.dragOptions?.start) {
			this.dragOptions.start(event);
		}
	}

	private animationFrameId: number | null = null;
	private mouseMove = (event: MouseEvent) => {
		if (this.animationFrameId) {
			cancelAnimationFrame(this.animationFrameId);
		}

		this.animationFrameId = requestAnimationFrame(() => {
			this.x = event.clientX - this.startX;
			this.y = event.clientY - this.startY;
			this.setPosition();

			if (this.dragOptions?.drag) {
				this.dragOptions.drag(event);
			}
		});
	};

	private mouseUp = (event: MouseEvent) => {
		document.removeEventListener('mousemove', this.mouseMove);
		document.removeEventListener('mouseup', this.mouseUp);

		if (this.dragOptions?.stop) {
			this.dragOptions.stop(event);
		}
	};

	private setPosition() {
		const elem = this.el.nativeElement;
		this.renderer.setStyle(elem, 'position', 'absolute');
		this.renderer.setStyle(elem, 'left', `${this.x}px`);
		this.renderer.setStyle(elem, 'top', `${this.y}px`);
	}
}
